import { useBreakpoint } from "@ecco/ui/use-breakpoint";
import { Field } from "formik";
import Selector from "./Selector";
import { Dropdown } from "./Dropdown";
import { styles } from "../baseFormStyles";

export const ResponsiveDropdownField = ({
    country,
    locale,
    setFieldValue,
    title,
    fieldName,
    isReadOnly = false,
    error,
    testId,
    items,
    dropdownStyle,
    dropdownPlacement = "bottom",
}) => {
    const md = useBreakpoint("md");

    return (
        <Field
            as={md ? Dropdown : Selector}
            country={country}
            locale={locale}
            setFieldValue={setFieldValue}
            title={title}
            field={fieldName}
            isReadOnly={isReadOnly}
            id={fieldName}
            name={fieldName}
            testId={testId}
            type="select"
            isError={Boolean(error)}
            sx={styles.formInput}
            styleButton={dropdownStyle}
            items={items}
            dropdownPlacement={dropdownPlacement}
        />
    );
};
